var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo2 = function SvgInfo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#info2_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "info2_svg__b",
    width: 56,
    height: 56,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56 0H0v56h56z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#info2_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFF6FF",
    d: "M52 28C52 14.745 41.255 4 28 4S4 14.745 4 28s10.745 24 24 24 24-10.745 24-24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBEAFE",
    strokeWidth: 8,
    d: "M52 28C52 14.745 41.255 4 28 4S4 14.745 4 28s10.745 24 24 24 24-10.745 24-24Z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A94E0",
    d: "M27.879 37.576a2.13 2.13 0 0 1-2.121-2.121c0-1.167.954-2.122 2.121-2.122S30 34.288 30 35.455a2.127 2.127 0 0 1-2.121 2.12M27.59 30.151c-.88 0-1.59-.71-1.59-1.59v-9.546c0-.88.71-1.59 1.59-1.59s1.592.71 1.592 1.59v9.546c0 .88-.71 1.59-1.591 1.59"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "info2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
};
export default SvgInfo2;